export const LOAD_COSTS = 'LOAD_COSTS';
export const SET_COST_PAGINATION = 'SET_COST_PAGINATION';
export const SET_COST_FILTER = 'SET_COST_FILTER';
export const SET_COST_SORT = 'SET_COST_SORT';
export const RESET_COST_FILTERS = 'RESET_COST_FILTERS';
export const ADD_COST = 'ADD_COST';
export const EDIT_COST = 'EDIT_COST';
export const SET_CHECKED_COST = 'SET_CHECKED_COST';
export const TOGGLE_COST_STATUS = 'TOGGLE_COST_STATUS';
